import type { ReactNode } from "react";
import type { ExternalToast } from "sonner";

// Lazy wrapper around sonner's `toast`. sonner is ~64KB raw and nothing on the
// first-paint render path needs it, but many components call `toast` in event
// handlers. Importing it statically dragged the whole library into the shared
// entry bundle. Dynamic-importing on first call keeps it out of the critical
// path; the toast fires a tick later once sonner loads, which is imperceptible
// for handler-triggered toasts.
//
// We only forward the methods the app actually uses (success/error/info) and
// nothing reads the returned toast id, so these are fire-and-forget.

type ToastMessage = ReactNode;

let loader: Promise<typeof import("sonner")> | null = null;
function sonner() {
	loader ??= import("sonner");
	return loader;
}

function forward(method: "success" | "error" | "info") {
	return (message: ToastMessage, data?: ExternalToast) => {
		void sonner().then((m) => m.toast[method](message, data));
	};
}

export const toast = {
	success: forward("success"),
	error: forward("error"),
	info: forward("info"),
};
